import { myReportTemplatesApi } from 'v5/api/report-templates/reportTemplates.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createReportTemplateMutationService } from './ReportTemplateMutationService.impl';

export const myReportTemplateMutationService =
  createReportTemplateMutationService({
    api: myReportTemplatesApi,
    getTimezone: () => Intl.DateTimeFormat().resolvedOptions().timeZone,
    services: {
      errorService: myErrorService,
      messageService: myMessageService
    }
  });
